<div class="modal-header">
    <h5 class="modal-title">Edit</h5>
</div>

<div class="modal-body">
    <form (submit)="save()">
        <div class="form-group">
            <label class="form-label" i18n>product_text_1</label>
            <div class="input-group mb-3">
                <input type="text" class="form-control" name="product_text_1"
                       [(ngModel)]="shipment_product_line.product_text_1">
            </div>
        </div>

        <div class="form-group">
            <label class="form-label" i18n>DB/SKU</label>
            <div class="input-group mb-3">
                <input type="text" class="form-control" name="product_number"
                       [(ngModel)]="shipment_product_line.product_number">
            </div>
        </div>

        <div class="form-group">
            <label class="form-label" i18n>Antal</label>
            <div class="input-group mb-3">
                <input type="number" class="form-control" name="amount"
                       [disabled]="disableAmount"
                       [(ngModel)]="shipment_product_line.amount">
            </div>
        </div>
        <div class="form-group">
            <label class="form-label" i18n>Weight (kg)</label>
            <div class="input-group mb-3">
                <input type="text" class="form-control" name="weight"
                       [ngModel]="shipment_product_line.weight"
                       (ngModelChange)="onWeightChange($event)"
                >
                <span class="input-group-text" id="basic-addon2">kg</span>
            </div>
        </div>

        <fieldset>
            <legend>DG</legend>

            <div class="d-flex gap-3 flex-nowrap">
                <div class="form-group">
                    <label class="form-label" i18n>UN</label>
                    <div class="input-group mb-3">
                        <span class="input-group-text" id="basic-addon2">UN</span>
                        <input type="text" class="form-control" name="dg_un"
                               [(ngModel)]="shipment_product_line.dg_un"
                        >
                    </div>
                </div>
                <div class="form-group">
                    <label class="form-label" i18n>Fareklasse</label>
                    <div class="input-group mb-3">

                        <select class="form-control form-select"
                                name="dg_class"
                                [(ngModel)]="shipment_product_line.dg_class"
                        >
                            <option i18n [value]="null">Vælg</option>
                            <ng-template ngFor let-possibleDgClass [ngForOf]="possibleDgClasses">
                                <option [ngValue]="possibleDgClass">{{ possibleDgClass }}
                                </option>
                            </ng-template>
                        </select>
                    </div>
                </div>
                <div class="form-group">
                    <label class="form-label" i18n>Emballage gruppe</label>
                    <div class="input-group mb-3">

                        <select class="form-control form-select"
                                name="dg_packaging_group"
                                [(ngModel)]="shipment_product_line.dg_packaging_group"
                        >
                            <option i18n [value]="null">Vælg</option>
                            <ng-template ngFor let-possiblepackaging_group [ngForOf]="possiblepackaging_groups">
                                <option [ngValue]="possiblepackaging_group">{{ possiblepackaging_group }}
                                </option>
                            </ng-template>
                        </select>
                    </div>
                </div>
            </div>
            <div class="form-group">
                <label class="form-label" i18n>Beskrivelse</label>
                <div class="input-group mb-3">
                    <input type="text" class="form-control" name="dg_description"
                           [(ngModel)]="shipment_product_line.dg_description"
                    >
                </div>
            </div>


            <div class="form-group" *ngIf="shipment_product_line.dg_un">
                <label class="form-label" i18n>Emballage</label>
                <div class="input-group mb-3">

                    <select class="form-control form-select"
                            name="shipment-route-id"
                            [(ngModel)]="shipment_product_line.dg_packaging"
                    >
                        <option i18n [value]="null">Vælg emballage</option>
                        <ng-template ngFor let-possiblePackaging [ngForOf]="possiblePackagings">
                            <option [value]="possiblePackaging">{{ possiblePackaging }}
                            </option>
                        </ng-template>
                    </select>
                </div>
            </div>
        </fieldset>
    </form>
</div>

<div class="modal-footer">
    <button (click)="close()" type="button" class="btn  btn-secondary" data-dismiss="modal"><span
            i18n>Close</span>
    </button>
    <button (click)="save()" type="button" class="btn  btn-primary">Gem</button>
</div>
